<div [class]="options?.cssClass + ' w-full'">

  <div *ngIf="options?.hidden == false" class="flex flex-row w-full">

    <div
      class="flex {{isMobile ? 'flex-col' : 'flex-row'}} gap-4 justify-center items-center w-full text-colored rounded-2xl p-2 mx-1">

      <!-- <p class="">
        Creato da: <b>{{data && data.createdBy  ? (data.createdBy + ' - ' + (data.creationDate |
        date:'dd/MM/yyyy HH:mm')) : 'dati non disponibili'}}</b>
      </p>



      <p class="">
        Ultima modifica: <b>{{data && data.editedBy ? (data.editedBy + ' - ' + (data.lastEditDate |
        date:'dd/MM/yyyy HH:mm')) : '-'}}</b>
      </p> -->


      <p class="">
        Data creazione: <b>{{data?.creationDate | date:'dd/MM/yyyy HH:mm'}}</b>
      </p>



      <p class="" *ngIf=" data?.lastEditDate != '0001-01-01T00:00:00'">
        Ultima modifica: <b>{{data?.lastEditDate | date:'dd/MM/yyyy HH:mm'}}</b>
      </p>

    </div>


  </div>
</div>